import axios from "axios";
import { returnErrors, clearErrors } from "./errorAction";
import { API_END_POINT } from "../../constants/api";

export const ADD_BUYER_SUCCESS = "ADD_BUYER_SUCCESS";
export const ADD_BUYER_FAIL = "ADD_BUYER_FAIL";
export const UPDATE_BUYER_SUCCESS = "UPDATE_BUYER_SUCCESS";
export const UPDATE_BUYER_FAIL = "UPDATE_BUYER_FAIL";
export const DELETE_BUYER_SUCCESS = "DELETE_BUYER_SUCCESS";
export const DELETE_BUYER_FAIL = "DELETE_BUYER_FAIL";
export const ADD_BUYER = "ADD_BUYER";
export const BUYER_INNER = "ADD_BUYER";
export const EDIT_BUYER = "EDIT_BUYER";
export const DELETE_BUYER = "DELETE_BUYER";
export const GET_BUYER = "GET_BUYER";
export const GET_BUYER_PAYMENTS = "GET_BUYER_PAYMENTS";
export const CLEAR_BUYER_STATE = "CLEAR_BUYER_STATE";

export function addBuyer(buyerData, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = JSON.stringify(buyerData);
    axios
      .post(`${API_END_POINT}/company/buyer/add`, body, config)

      .then((res) => {
        dispatch({
          type: ADD_BUYER,
          payload: res.data,
        });
        dispatch({
          type: ADD_BUYER_SUCCESS,
          payload: res.data,
        });
      })

      .catch((err) =>
        dispatch({
          type: ADD_BUYER_FAIL,
          payload: err.response.data.message,
        })
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function getBuyer(company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios

      .get(`${API_END_POINT}/company/buyer/get-buyer/company/${company_id}/limit=100`, config)
      .then((res) =>
        dispatch({
          type: GET_BUYER,
          payload: res.data,
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };
}

export function deleteBuyer(id, company_id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios
      .delete(`${API_END_POINT}/company/buyer/delete/${id}`, config)
      .then((res) =>
        dispatch({
          type: DELETE_BUYER,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Buyer Delete Successfully", 201, "DELETE_BUYER_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "DELETE_BUYER_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function editBuyer(buyerUpdated, id) {
  console.log(buyerUpdated, id);
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log(buyerUpdated, id);
    const body = JSON.stringify(buyerUpdated);
    axios
      .put(`${API_END_POINT}/company/buyer/edit/${id}`, body, config)
      .then((res) => {
        dispatch({
          type: EDIT_BUYER,
          payload: res.data[0],
        });
        //         UPDATE_BUYER_SUCCESS
        // UPDATE_BUYER_FAIL
        dispatch({
          type: UPDATE_BUYER_SUCCESS,
          payload: res.data[0],
        });
      })
      // .then((data) =>
      //   dispatch(
      //     clearErrors("Buyer Update Successfully", 201, "UPDATE_BUYER_SUCCESS")
      //   )
      // )
      // .then(() => dispatch(clearErrors()))
      .catch(
        (err) =>
          dispatch({
            type: UPDATE_BUYER_FAIL,
            payload: err.response.data,
          })
        // dispatch(
        //   returnErrors(
        //     err.response.data,
        //     err.response.status,
        //     "UPDATE_BUYER_FAIL"
        //   )
        // )
      );
    // .then(() => dispatch(clearErrors()));
  };
}

export function getBuyerPayments(params) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify(params);
    axios
      .post(`${API_END_POINT}/api/Contract/Payment/Get`, body, config)
      .then((res) =>
        dispatch({
          type: GET_BUYER_PAYMENTS,
          payload: res.data,
        })
      )
      .catch((err) => console.log("Error", err));
  };
}

export function buyerInner(buyerData) {
  return { type: BUYER_INNER, payload: buyerData };
}

export function clearBuyerState() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_BUYER_STATE,
    });
  };
}
